module.exports = __webpack_public_path__ + "assets/img/slider-3.e5ae7c76.jpg";